import React from 'react'
import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import {
  osName,
} from 'react-device-detect'
import {
  WarrantyAdditionalInformationWrapper
} from './styled'
import {
  Section,
  Text,
  Image,
  Grid,
  Table,
  ShapeContainer,
} from './../../../../components'
import {
  VARIABLES,
} from './../../../../themes'

/**
 * Warranty description:
 * - Warranty
 */

export class WarrantyBSWMVietnamAdditionalInformation extends React.PureComponent {
  render() {
    const {
      additionalProjectInformation,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'warranty-bswm-additional-information',
    )

    return (
      <WarrantyAdditionalInformationWrapper
        className={classes}
      >
        <Section spacingBottom='10'>
          <Section spacingBottom='5'><p className='warranty-bswm-text is-sm'>Additional Project Information:</p></Section>
          <p className='warranty-bswm-text is-sm is-bold'>{additionalProjectInformation}</p>
        </Section>
      </WarrantyAdditionalInformationWrapper>
    )
  }

  static defaultProps = {
    // If you set new default props, you should create propsType for correct styleguide document.
    additionalProjectInformation: '< Additional Project Information >',
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
